/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown> }} Countdown_HourInputs */

const en_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} h`)
};

const ar_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} ساعة`)
};

const de_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} h`)
};

const es_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} h`)
};

const fr_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} h`)
};

const it_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} h`)
};

const ja_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}時間`)
};

const ko_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}시간`)
};

const pt_br_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} h`)
};

const ru_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} ч.`)
};

const th_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} ช.`)
};

const tr_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} sa`)
};

const zh_cn_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 时`)
};

const zh_tw_countdown_hour = /** @type {(inputs: Countdown_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 時`)
};

/**
* | output |
* | --- |
* | "{hour} h" |
*
* @param {Countdown_HourInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const countdown_hour = /** @type {((inputs: Countdown_HourInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Countdown_HourInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_countdown_hour(inputs)
	if (locale === "ar") return ar_countdown_hour(inputs)
	if (locale === "de") return de_countdown_hour(inputs)
	if (locale === "es") return es_countdown_hour(inputs)
	if (locale === "fr") return fr_countdown_hour(inputs)
	if (locale === "it") return it_countdown_hour(inputs)
	if (locale === "ja") return ja_countdown_hour(inputs)
	if (locale === "ko") return ko_countdown_hour(inputs)
	if (locale === "pt_br") return pt_br_countdown_hour(inputs)
	if (locale === "ru") return ru_countdown_hour(inputs)
	if (locale === "th") return th_countdown_hour(inputs)
	if (locale === "tr") return tr_countdown_hour(inputs)
	if (locale === "zh_cn") return zh_cn_countdown_hour(inputs)
	return zh_tw_countdown_hour(inputs)
});